import { useEffect, useState } from 'react';
import useAuth from "../hooks/useAuth";
import TextEditor from "./TextEditor";
import { Markup } from 'interweave';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import Loader from './Loader';
import SingleFileDrop from './SingleFileDrop';
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ToastContainer, toast } from 'react-toastify';
import PageFileDrop from "./PageFileDrop"
import SearchBoxNew from "./SearchBoxNew"

const Page = ({ slug, title, userZip, userCity, startingService }) => {

	const axiosPrivate = useAxiosPrivate();
	const [loading, setLoading] = useState(false);

	const { auth, editing, setEditing } = useAuth()
	const [page, setPage] = useState()
	const [pageID, setPageID] = useState()
	const [markets, setMarkets] = useState()
	const [files, setFiles] = useState([])

	const [bannerOpen, setBannerOpen] = useState(false)
	const [uploadOpen, setUploadOpen] = useState(false)
	const [pageImages, setPageImages] = useState([])
	const [selectedImage, setSelectedImage] = useState()

	const [bannerImage, setBannerImage] = useState()

	const imageHouseData = "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"
	const imageGlassData = "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"
	const imagePointerData = "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"
	const imageCheckmarkData = "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALUSURBVHgBvVdNUhpREP7eG8yPViUcwdwAl8kmZJmVsDBCNoETCKKVpbhM0ARPACwiFYuqcIPgJmYHN5AjYKqiVcLMS/ebUDIyvzr4VVHMm2nm+7pfd79GICxK7VUsGeuAStMqBSWSdJ3UzwSGtB7SugdlneIw3wv7WhFoUWmnIYy9/8Rh3zqkTxWfN1vBpl74SB6bRiMSsZsQab3Bp/zQy0S63q0cZ4i8fy9yhgI5Ic9R+V71MjHm7myfFCBFm66eIC4IpPFyQ+Cs04OvAPbcJo8fHiJucoD33JI/ddgWCUU5MVMlNzlgGV8XTq4ZZQOlRtIpYLddgFIZPATYycTyllOAMj4gdoiRz8PSNApS7/19y20eVUzMNfJ26PE8icdPX9sCLG6vMUKpJg4291Gn5iNFz9NugowtAFQesZGTx+ZVWV9z81Gq4G0s0raAuDJfk1OJ1Ysj3U8E9nztBfFSHlAEVAqxwCzrsHNOSSrpMDCePZeBRkKVIIRfQjGqOHzf1ZkdpZlJc9VfAJOOr1qovRvo8LqJmCYdY2klYjMbX0h9ZHqB92lpua/DyuE1H61RNLoOgaGTzo3/ekgREANfI/aIw7r7LYV6dkTRyIJDHjXp5jHi31IVqEGgKYtQiT52jkt6zSHX5BGTzvlSzSv1DBcaRDQdLpg8atI5+EWTv+zjeOekH6kcBboYXxbtpIu471NMrBfshF0FlnkU5bfkcQaJlfM7k3Pl1O050RbwJd8MqHO3tyRxJ9Apaar96WqmD1hFPASEVZ167xTAY5KlylgoVB21nGO7nUPpWec3Xm3wVRrxY4CDXPb2zfmx/FfnNHYRgtt17q3bI/ezgBuNQjZ6Ys4xj/RhVst55pf/f8PSjyQS11skpKDPhSjEvN+TyyPdqv0sERbbNDkbch0W/TN2FaO97dF3D+O/rSDi6AJmwS2Yhgk+z2mmpEPpz0VYwtv4Bx/UK+BB8E3XAAAAAElFTkSuQmCC"
	const imageXData = "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANrSURBVHgBtVdNUhpBFH49A8ouHGGOoCcI7JKNwgmExKTKlXgCzQkkK6uS6OgqS1PmAOIuO72BHAGLjTAz3fleM4PodM80hrwqYKp5/f7f994IcqSwVgtoOt0mIRqk1IYSoo5j/pBQaojzIc4H5Hk33TgeuMoVZQxhpcIKDxVRg9xpiM/RhyS5KGO0GqA9jqJwScU5QybVanPv8XFoY/BMhz98v6Wi6PYflTMF61F0f1qpHNkY/JcHp9Vqx1PqJx5rtCJCmBtbvi+upBxQkQHseap85WQzYl4DnHOE/RqPAf1HSoRoflrokqcaiKJjm3KlVB8/I3Ik8J/b+H2lwjBt37kBp77fQcG1bMo/SnkAy9vkpvwI/F2RJJsWlgBYsf/MAHzt2AQKIVonSA+HDcIPqJgGUP5FG+L7PRsTQKyXRcHTuS9ut2B9Or3kCxDeZw/NUtUQXusopW23XyCzDgPfagM0vJaREBvS90N+ZA/TmnimfCJls4u8o417gObDMpFZyj2N7Q6EdmnBs+PUCE7FIPsvlrK9B9T7Vq1uCClLlWt5SjW0AfAmIEfCpV6Gajrc8Fzi7DPRHaeyIuUlLVR4sTARcFrFme8rWpIkUWcXg4YFcNjDer2uxuNbWhJDZJIEHr2CcKl/AmXdrNfHYyuGlMh5nQEI/ai2ADSxEKVj10Qx0YOnl4nllC9WfGcJjMhRFYXLXXDnfAOes3KueF5UUPGhE0aYacROeBDqbIAUoquVM3gB0/XhDCOy9mQUdE2H1uvF2OFcuNk7VP4v09QERnSy9sQa1nF06lwboEdjyYV0IM0wPo4vyVDxjH5zjECaqKS2JkmiHdddgOHwtYB3kCIfATP6vBHbGNkILDU7nFtthGUk87jemy2uTwvJmefdMzoZuO8ma2vttTjuuGA8K0Vam5j7LSP/rJA3cwZ8R1Xj0rVFKDMH5E7suRGSGbp3pZxHfL4T/pZyuCXEA+b/O8M9N3x/IuNCy7W0m9ZSzgCmK6X+wAheQhq0akIqUUu5rSq3lsOIm1UbwUUH5e9N/xlnAbccJl6bloXpvOYR55x3RBtL4bshQ6zEAslAY+yQAsWY8X0PxdYt2aZLX04z4s0ZP9uCccDcriPgycDjN2QpL7qOa7yzAYvEkUmI3vA8R6qGKKQHV4Uv6S+lSNoGBHSRxgAAAABJRU5ErkJggg=="

	const handleBannerClose = () => {
		setBannerOpen(false)
	};

	const handleUpload = () => {
		setBannerOpen(false)
		setUploadOpen(true)
	};

	const handleUploadClose = () => {
		setUploadOpen(false)
		setBannerOpen(true)
	};

	const insertImage = () => {
		setBannerOpen(true)
	};

	const handleUploadImage = () => {
		setUploadOpen(false)
	};

	const saveBannerImage = async (e, banner) => {
		const dismiss = () =>  toast.dismiss(updatePageToast.current);
		const updatePageToast = toast.loading("Updating Banner Image");

		const controller = new AbortController();
		setLoading(true);
		try {
			const response = await axiosPrivate.put('page/' + pageID,
			JSON.stringify({banner_photo_url: banner}),
			{
				signal: controller.signal
			});

			// If successful set banner image and close popups
			setBannerImage(banner)
			setUploadOpen(false)
			setBannerOpen(false)

			toast.update(updatePageToast, { render: 'Banner Image Updated', type: 'success', isLoading: false, autoClose: 5000});

		} catch (err) {
			if (!err?.response) {
				toast.update(updatePageToast, { render: 'No Server Response', type: 'error', isLoading: false, autoClose: 5000});
				{/* setErrMsg('No Server Response'); */}
			} else if (err.response?.status === 401) {
				toast.update(updatePageToast, { render: 'Authorization Failed', type: 'error', isLoading: false});
				{/* setErrMsg('The email has already been taken.'); */}
			} else {
				toast.update(updatePageToast, { render: 'Banner Update Failed', type: 'error', isLoading: false, autoClose: 5000});
				{/* setErrMsg('Registration Failed'); */}
			}
			{/* errRef.current.focus(); */}
		}
		return () => controller.abort();

	}

	const handleRemoveBanner = async (e) => {
		const dismiss = () =>  toast.dismiss(updatePageToast.current);
		const updatePageToast = toast.loading("Deleting Banner Image");

		const controller = new AbortController();
		setLoading(true);
		try {
			const response = await axiosPrivate.put('page/' + pageID,
			JSON.stringify({banner_photo_url: ""}),
			{
				signal: controller.signal
			});

			// If successful set banner image and close popups
			setBannerImage("")
			setBannerOpen(false)
			setUploadOpen(false)

			toast.update(updatePageToast, { render: 'Banner Image Deleted', type: 'success', isLoading: false, autoClose: 5000});
		} catch (err) {
			if (!err?.response) {
				toast.update(updatePageToast, { render: 'No Server Response', type: 'error', isLoading: false, autoClose: 5000});
				{/* setErrMsg('No Server Response'); */}
			} else if (err.response?.status === 401) {
				toast.update(updatePageToast, { render: 'Authorization Failed', type: 'error', isLoading: false});
				{/* setErrMsg('The email has already been taken.'); */}
			} else {
				toast.update(updatePageToast, { render: 'Banner Image Delete Failed', type: 'error', isLoading: false, autoClose: 5000});
				{/* setErrMsg('Registration Failed'); */}
			}
			{/* errRef.current.focus(); */}
		}
		return () => controller.abort();


	}

	const getPage = async () => {
		const controller = new AbortController();
		setLoading(true);
		try {
			const response = await axiosPrivate.get('page-by-slug/' + slug, {
				signal: controller.signal
			});
			setPage(response.data.page);
			setPageID(response.data.page.id)
			setBannerImage(response.data.page.banner_photo_url)
			setMarkets(response.data.markets)
			setPageImages(response?.data.images)
			setLoading(false)
		} catch(err) {
			console.log(err.message);
			{/* !auth && navigate('/login', { state: { from: location }, replace: true }); */}
		}
		return () => controller.abort();
	}

	useEffect(() => {
		getPage();
		// eslint-disable-next-line
	},[])


	useEffect(() => {
		if (editing == true && (auth?.user?.role === "5150" || auth?.user?.role === "127001")){
			document.body.classList.add('editing')
		} else {
			document.body.classList.remove('editing');
		}
		// Update data anytime page editing is changed
		getPage();
	}, [editing])

	return (
		<>
		{editing && (auth?.user?.role == 5150 || auth?.user?.role == 127001) ?
			<>
				{bannerImage &&
					<section className='banner'>
						<img src={`https://storage.iyh.app/${bannerImage}`} alt="" />
					</section>
				}
				<article className='inner'>
					<h3>Editing Page</h3>
					<p className="slug">Page Slug: { slug }</p>
					{/* <SingleFileDrop files={files} setFiles={setFiles} /> */}
					<button className="changeBanner" onClick={insertImage}>Update Banner</button>
					{ slug !== "home" &&
						<TextEditor content={page?.content} id={page?.id} pageImages={pageImages} setPageImages={setPageImages} />
					}
					{slug === 'media-kit' && markets?.length &&
							<>
							<h3>Active Markets</h3>
							<ul className="marketList">
								{markets.map((market, i) =>
									<li key={i}>
										<div className="name">
											{market?.market_name}
										</div>

									</li>
								)}
							</ul>
							</>
					}

				</article>
			</>
		:
		<>

			{loading && <article className='inner'><Loader /></article>}
			{!loading && page &&
				<>
					{bannerImage &&
						<section className='banner'>
							<img src={`https://storage.iyh.app/${bannerImage}`} alt="" />
							{ slug == "home" && <SearchBoxNew userZip={userZip} startingService={startingService}/>}
						</section>
					}
					{/* { slug !== "home" && <>
						<div className={"how-homeowners-choose-wrapper"}>
							<div className={'how-homeowners-choose-title'}>
								<em>
									How Homeowners choose <strong>YOU!</strong>
								</em>
							</div>
							<div className="columns-3">
								<div className="column">
									<img src={`data:image/png;base64,${imageHouseData}`} />
									<div>Homeowners join ImproveYourHouse.com for FREE.</div>
								</div>
								<div className="column">
									<img src={`data:image/png;base64,${imageGlassData}`} />
									<div>Using our online directory, homeowners search locally for the Home Pro they need.</div>
								</div>
								<div className="column">
									<img src={`data:image/png;base64,${imagePointerData}`} />
									<div>If your Home Pro account matches their needs and location, they can send you their project details or contact directly!</div>
								</div>
							</div>
						</div>
						<div className={'compareTableWrapper'}>
							<table className={'comparison-table'}>
								<thead>
									<th>Features</th>
									<th>ImproveYourHouse</th>
									<th>"The Other Guys"</th>
								</thead>
								<tbody>
									<tr>
										<td>
											<span class={'text-blue'}>Low, Fixed Monthly Subscription Fee:</span><br/>Pay a simple, predictable monthly fee.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Homeowners Reach Out to You:</span><br/>No more cold calling—homeowners contact you directly.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Real Opportunities: Get genuine,</span><br/>up-to-date leads without extra charges.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Real-Time Analytics: </span>Track your leads, profile visits, website clicks, calls, favorite status and more.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Dedicated In-House Marketing and Design Team:</span> Stand out with expert support included.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Upfront Marketing Options: </span>Choose from various upgraded options and tiers to boost your marketing.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Exclusive Print Magazine: </span>Advertise in our high-end magazine delivered to top-earning homeowners in your service areas.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Poor Leads: </span>No oversold, outdated, or unreliable leads that waste your time and money.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Fight for Refunds: </span>Waste your valuable time demanding lead fee refunds or credits.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Constant Rebranding: </span>Confuses homeowners, erodes credibility.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
									</tr>
									<tr>
										<td>
											<span className={'text-blue'}>Contractors Pay to Chase Leads: </span>You're on your own when reaching out to leads, often never making contact.
										</td>
										<td>
											<img src={`data:image/png;base64,${imageXData}`} />
										</td>
										<td>
											<img src={`data:image/png;base64,${imageCheckmarkData}`} />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</>
					} */}
					{ slug !== "home" &&
						<article className='inner content'>
							{title && <h1>{title}</h1>}
							<Markup content={page?.content} />
							{slug == 'media-kit' && markets?.length &&
									<>
									<h3>Active Markets</h3>
									<ul className="marketList">
										{markets.map((market, i) =>
											<li key={i}>
												<div className="name">
													{market?.market_name}
												</div>

											</li>
										)}
									</ul>
									</>
							}
						</article>
					}
				</>
			}

			{!loading && !page?.content && <article className='inner'><p>No Page Content Available</p></article>}

		</>
		}
		{/* Add Banner Image Dialog */}
		<Dialog
			open={bannerOpen}
			onClose={handleBannerClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogTitle id="alert-dialog-title">
			  {"Change Banner Image"}
			</DialogTitle>
			<DialogContent>
			  <>
				  <p>Click on a image to insert to the page or click add to upload a new one.</p>
				<ul className="pageImages">
				{pageImages?.map((image, i) =>
					<li key={i} onClick={(e) => saveBannerImage(e, image.path)}><img src={`https://storage.iyh.app/${image.path}`} alt={image.name} /></li>
				)}
				</ul>
			  </>
			</DialogContent>
			<DialogActions>
			  <button className="cancel" onClick={handleBannerClose}>Cancel</button>
			  <button className="cancel" onClick={handleRemoveBanner}>Remove Banner Image</button>
			  <button className="confirm" onClick={handleUpload}>Add</button>
			</DialogActions>
		  </Dialog>

		{/* Upload Image Dialog */}
		<Dialog
			open={uploadOpen}
			onClose={handleUploadClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogTitle id="alert-dialog-title">
			  {"Upload Image(s)"}
			</DialogTitle>
			<DialogContent>
			  <>
				  <PageFileDrop showFiles="true" autoUpload="" limit={10} multiple="true" accept="" buttonTitle="" handleUploadImage={handleUploadImage} setPageImages={setPageImages} pageImages={pageImages} />
			  </>
			</DialogContent>
			<DialogActions>
			  <button className="cancel" onClick={handleUploadClose}>Cancel</button>
			  {/* <button className="confirm" onClick={handleUploadImage}>Upload New</button> */}
			</DialogActions>
		  </Dialog>
		</>
	)
}

export default Page